export default {"src":"/_next/static/media/logo-yellow.6e270f86.svg","height":96,"width":551,"blurWidth":0,"blurHeight":0};